// extracted by mini-css-extract-plugin
export default {"tableCell":"VirtualTable_tableCell__2xV6j","tableRow":"VirtualTable_tableRow__JWQ8K","emptyList":"VirtualTable_emptyList__p0srG","skeleton":"VirtualTable_skeleton__2QY1P"};